import axios, { AxiosResponse } from 'axios';

export interface IIsinSelectData {
    emise: {
        isin: string;
        isinnazev: string;
        emic: string;
        emicnazev: string;
        evidence: 'DLT' | 'CDCP';
    }[];
}

export const isinSelectApi = (sluzba: string) => {
    // sluzba napr F42, F18 etc
    return axios({
        method: 'GET',
        url: '/Sluzby/Emiselist',
        params: {
            sluzba: sluzba
        }
    }).then((resp: AxiosResponse<IIsinSelectData>) => resp.data);
};
